import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { StorageService } from '@coin-depo-core/storage';

export interface INotRespond {code: string; parent_id: string}

@Injectable({
  providedIn: 'root',
})
export class ServerNotRespondingService {
  private hasError = new BehaviorSubject<INotRespond | null>(
    this.storage.get('server-not-responding', null)
  );
  hasError$ = this.hasError.asObservable();

  constructor(private storage: StorageService) {}

  hasErrorSnapshot() {
    return this.hasError.value;
  }

  enableFullscreenError(errorData: INotRespond) {
    this.hasError.next(errorData);
    this.storage.set('server-not-responding', errorData);
  }

  disableFullscreenError() {
    this.hasError.next(null);
    this.storage.set('server-not-responding', null);
  }
}
